export default __webpack_public_path__ + "static/05_Dragon-a67ada604608b8be88a53bf23bec3a6a.png";